import HttpService from './HttpService';

class PollService extends HttpService {
  constructor() {
    super();
  }

  vote(pollId, questionId, answersIds) {
    return this.http
      .put(`/api/poll/${pollId}/votes`, {
        Votes: answersIds.map(answerId => {
          return {
            QuestionID: questionId,
            AnswerID: answerId
          };
        })
      })
      .then(this.onResponse)
      .catch(this.onError);
  }
}

export default new PollService();
